// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import Carousel from "./carousel_controller";
application.register("carousel", Carousel);

import FaqController from "./faq_controller";
application.register("faq", FaqController);

import FormatPhoneController from "./format_phone_controller";
application.register("format-phone", FormatPhoneController);

import TabsController from "./tabs_controller";
application.register("tabs", TabsController);

import ToastController from "./toast_controller";
application.register("toast", ToastController);

import ValueSliderController from "./value_slider_controller";
application.register("value-slider", ValueSliderController);
